import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import CreateHQLocationPageContent from '../PageContent/CreateHQLocationPageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';


const CreateHQLocation = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo}>
            <PageTitle heading="Who owns this portal?" subheading="This is the organization that owns all portal data." />
            <SectionDivider width="70%" />
            <CreateHQLocationPageContent />
        </HeaderAndBodyLayout>
    )
}
export default CreateHQLocation;